import { ENTER_KEYCODE } from 'coreOld/constants';

export const resetFields = (object) =>
  Object.keys(object).reduce((obj, type) => ({ ...obj, [type]: null }), {});

export const enterPress = (e, action: () => void) => {
  if (e?.keyCode === ENTER_KEYCODE) {
    action();
  }
};
